var map = {
	"./angry.svg": 82119,
	"./anguish.svg": 44779,
	"./angular-icon.svg": 67076,
	"./app-store.svg": 8033,
	"./appstore.svg": 62612,
	"./award-new.svg": 30254,
	"./award.svg": 72747,
	"./badge.svg": 12841,
	"./book-2.svg": 91434,
	"./book-3.svg": 9275,
	"./book-icon.svg": 62803,
	"./book.svg": 60783,
	"./bookmark.svg": 11376,
	"./building.svg": 76760,
	"./career-01.svg": 16134,
	"./career-02.svg": 47909,
	"./career-03.svg": 50660,
	"./career-04.svg": 34603,
	"./cart.svg": 13050,
	"./certificate.svg": 17589,
	"./certified-course-icon.svg": 14235,
	"./chapter.svg": 59519,
	"./chart.svg": 57416,
	"./check-circle.svg": 42165,
	"./check-round-1.svg": 38673,
	"./check-round-2.svg": 74626,
	"./check-round-3.svg": 88851,
	"./check-round.svg": 31639,
	"./clock.svg": 7010,
	"./close-circle.svg": 29761,
	"./cloud-icon-1.svg": 24361,
	"./cloud-icon-2.svg": 56250,
	"./cloud-icon-3.svg": 70859,
	"./cloud-icon-4.svg": 66180,
	"./cloud.svg": 29691,
	"./company-logo-1.svg": 17421,
	"./company-logo-2.svg": 34446,
	"./company-logo-3.svg": 49087,
	"./count-four.svg": 33482,
	"./count-one.svg": 27002,
	"./count-three.svg": 50994,
	"./count-two.svg": 78820,
	"./course-01.svg": 59097,
	"./course-02.svg": 67722,
	"./course-03.svg": 28091,
	"./course-04.svg": 18324,
	"./docker.svg": 89892,
	"./document.svg": 33811,
	"./dollar-circle.svg": 33735,
	"./ellipse-1.svg": 79528,
	"./ellipse-2.svg": 30267,
	"./ellipse-3.svg": 69898,
	"./email.svg": 32376,
	"./expert-tutor-icon.svg": 87835,
	"./favourite-01.svg": 82247,
	"./favourite-02.svg": 94388,
	"./favourite-03.svg": 36373,
	"./favourite-04.svg": 9610,
	"./favourite-05.svg": 43803,
	"./fb-icon.svg": 37682,
	"./figma.svg": 39764,
	"./framework-01.svg": 84212,
	"./framework-02.svg": 71156,
	"./framework-03.svg": 85558,
	"./framework-04.svg": 42393,
	"./github-icon.svg": 75025,
	"./google-icon.svg": 81777,
	"./google-play.svg": 7928,
	"./googleplay.svg": 35351,
	"./graduation-hat-icon.svg": 68014,
	"./graduation.svg": 24828,
	"./heart.svg": 17324,
	"./home-search-six.svg": 39813,
	"./icon-01.svg": 25109,
	"./icon-02.svg": 4822,
	"./icon-03.svg": 51687,
	"./icon-04.svg": 49288,
	"./icon-05.svg": 45305,
	"./icon-06.svg": 96010,
	"./icon-07.svg": 64827,
	"./icon-08.svg": 62588,
	"./icon-09.svg": 91133,
	"./icon-1.svg": 84557,
	"./icon-10.svg": 47127,
	"./icon-11.svg": 41798,
	"./icon-12.svg": 89925,
	"./icon-13.svg": 92676,
	"./icon-14.svg": 60267,
	"./icon-15.svg": 66394,
	"./icon-16.svg": 27561,
	"./icon-17.svg": 2200,
	"./icon-18.svg": 12415,
	"./icon-19.svg": 97774,
	"./icon-2.svg": 55438,
	"./icon-20.svg": 56642,
	"./icon-21.svg": 61811,
	"./icon-22.svg": 41056,
	"./icon-23.svg": 77009,
	"./icon-24.svg": 78510,
	"./icon-25.svg": 6943,
	"./icon-26.svg": 27916,
	"./icon-27.svg": 26861,
	"./icon-3.svg": 76543,
	"./icon-4.svg": 17984,
	"./import.svg": 58183,
	"./joing-01.svg": 30665,
	"./joing-02.svg": 15578,
	"./joing-03.svg": 34635,
	"./joing-04.svg": 72484,
	"./key.svg": 61181,
	"./lab-img-1.svg": 21793,
	"./lab-img-10.svg": 95907,
	"./lab-img-11.svg": 41618,
	"./lab-img-2.svg": 40050,
	"./lab-img-3.svg": 89443,
	"./lab-img-4.svg": 61788,
	"./lab-img-5.svg": 73981,
	"./lab-img-6.svg": 61886,
	"./lab-img-7.svg": 24463,
	"./lab-img-8.svg": 66312,
	"./lab-img-9.svg": 48057,
	"./laravel-icon.svg": 56835,
	"./like.svg": 82513,
	"./lock.svg": 99877,
	"./mail-2.svg": 99732,
	"./master-skill-icon-1.svg": 4718,
	"./master-skill-icon-2.svg": 33837,
	"./master-skill-icon-3.svg": 54124,
	"./master-skill-icon-4.svg": 38163,
	"./message-text.svg": 51191,
	"./messages.svg": 60668,
	"./mobile.svg": 99014,
	"./money-add.svg": 72298,
	"./nord-js.svg": 28321,
	"./notification.svg": 63965,
	"./online-course-icon.svg": 10537,
	"./online-course-img.svg": 58535,
	"./online-student-icon.svg": 43943,
	"./paypal-icon.svg": 64569,
	"./people.svg": 80049,
	"./php-course-icon.svg": 5232,
	"./php.svg": 72664,
	"./plane-icon.svg": 63464,
	"./play-01.svg": 93758,
	"./play-icon.svg": 3912,
	"./play.svg": 72494,
	"./python.svg": 27526,
	"./qr.svg": 78993,
	"./react.svg": 3149,
	"./search-icon.svg": 90542,
	"./sign-right-arrow.svg": 12782,
	"./sign.svg": 58619,
	"./skill-01.svg": 41649,
	"./skill-02.svg": 4930,
	"./skill-03.svg": 26451,
	"./skill-04.svg": 92556,
	"./smile.svg": 33524,
	"./smily.svg": 51232,
	"./spinner.svg": 4687,
	"./spinner2.gif": 83060,
	"./spinnerloading.gif": 79394,
	"./student-icon.svg": 70117,
	"./student.svg": 34065,
	"./swift.svg": 57145,
	"./teacher.svg": 28394,
	"./time.svg": 323,
	"./timer-icon.svg": 30655,
	"./timer-start.svg": 2248,
	"./timer.svg": 12635,
	"./twitter-x-icon.svg": 52136,
	"./user-graduate-icon.svg": 73361,
	"./user-icon.svg": 61989,
	"./user-octagon.svg": 4143,
	"./user-tag.svg": 80126,
	"./user-tick.svg": 71693,
	"./users.svg": 5600,
	"./video.svg": 13617,
	"./voice.svg": 77094,
	"./wallet.svg": 58591,
	"./winning.svg": 12664,
	"./wish.svg": 66037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30494;